import { Table } from '@alifd/next';
import React, { Dispatch } from 'react';
import $i18n from '@/i18n';
import Confirm from '@/components/Confirm';
import EditablePane from '../editablePane';
import { Modal } from 'antd';
import { Icon, Message } from '@b-design/fusion';
import './index.less';
import Requests from '@/services/request';
import { copy } from '@/utils/config';

interface Edit {
  callerData: any[];
  setCallerData: Dispatch<any[]>;
  channelCode: string;
}

const Edit: React.FC<Edit> = ({ callerData, setCallerData, channelCode }) => {
  const skCopy = (accessKey, e) => {
    Requests.get('/rest/intercnn/channel/target/secretKey', { accessKey, channelCode }).then(
      (data) => {
        if (data?.secretKey) {
          if (document.execCommand('Copy')) {
            copy(data?.secretKey, e);
            return;
          }
          
          const modal = Modal.info({
            icon: null,
            mask: true,
            centered: true,
            closable: true,
            maskStyle: { zIndex: 1001 },
            title: $i18n.get({ id: 'aopf.component.edit.SkReplication', dm: 'SK 复制' }),
            content: (
              <div className="custom-copy-superapp-modal-copy-content">
                <span className="custom-copy-superapp-modal-copy-value">{data.secretKey}</span>
              </div>
            ),
            okText: $i18n.get({
              id: 'aopf.pages.channel.setUpChannelCallerColumns.render.copy',
              dm: '复制',
            }),
            onOk: (e) => {
              copy(data.secretKey, e);
              modal.destroy()
            },
            wrapClassName: 'custom-copy-superapp-modal-wrap',
          });
        }
      },
    );
  };

  const deleteCaller = async (key, params) => {
    if (Number(key)) {
      const newData = callerData.filter((item) => item.accessKey !== key);
      setCallerData(newData);
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
          dm: '删除成功',
        }),
      });
    } else {
     const data = await Requests.post('/rest/intercnn/channel/target/delete', { ...params })
        if (data) {
          const newData = callerData.filter((item) => item.accessKey !== key);
          setCallerData(newData);
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
              dm: '删除成功',
            }),
          });
        }
    }
  };

  const handleAdd = () => {
    const newKey = Math.floor(Math.random() * 1000000).toString();
    const newData = {
      accessKey: newKey,
      identifier: '',
      type: '',
    };
    setCallerData([...callerData, newData]);
  };

  const renderCellInput = (_, __, record) => {
    return (
      <EditablePane
        type={'Input'}
        record={record}
        setDataSource={setCallerData}
        dataSource={callerData}
      />
    );
  };

  const renderCellSelect = (_, __, record) => {
    return (
      <EditablePane
        type={'Select'}
        record={record}
        setDataSource={setCallerData}
        dataSource={callerData}
      />
    );
  };

  const asKeyCell = (_, __, record) => {
    return (
      <div>
        <span>
          {$i18n.get({ id: 'aopf.component.edit.ChineseAk', dm: 'ak:' })}{' '}
          {!(record?.accessKey - 0) ? (
            <a
              style={{ textDecoration: 'underline', color: 'var(--superapp-primary-1)' }}
              onClick={(e) => {
                copy(record?.accessKey, e);
              }}
            >
              {$i18n.get({
                id: 'aopf.pages.channel.setUpChannelCallerColumns.render.copy',
                dm: '复制',
              })}
            </a>
          ) : (
            '--'
          )}
        </span>
        <span style={{ margin: '0px 5px' }}>/</span>
        <span>
          {$i18n.get({ id: 'aopf.component.edit.ChineseSk', dm: 'sk:' })}{' '}
          {!(record?.accessKey - 0) ? (
            <a
              style={{ textDecoration: 'underline', color: 'var(--superapp-primary-1)' }}
              onClick={(e) => {
                skCopy(record?.accessKey, e);
              }}
            >
              {$i18n.get({
                id: 'aopf.pages.channel.setUpChannelCallerColumns.render.copy',
                dm: '复制',
              })}
            </a>
          ) : (
            '--'
          )}
        </span>
      </div>
    );
  };

  const actions = (_, __, record) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
        <Confirm
          trigger={
            <div style={{ color: 'var(--superapp-primary-1)' }}>
              <Icon type="trash-can--outline" size={'xs'} style={{ paddingRight: '5px' }} />
              <a style={{ color: 'var(--superapp-primary-1)' }}>
                {$i18n.get({
                  id: 'aopf.pages.miniapp.detail.info.btn.Delete',
                  dm: '删除',
                })}
              </a>
            </div>
          }
          dialogTitle={$i18n.get({
            id: 'aopf.pages.channel.channelList.message.deleteTitle',
            dm: '删除',
          })}
          dialogContent={$i18n.get({
            id: 'aopf.pages.channel.channelList.message.deleteContent',
            dm: '确定删除该内容?',
          })}
          onClick={deleteCaller.bind(null, record?.accessKey, {
            channelCode: record?.channelCode,
            identifier: record?.identifier,
          })}
          style={{ display: 'inline-block' }}
        />
      </div>
    );
  };

  return (
    <div className="appSetting-editTable">
      <Table dataSource={callerData} primaryKey="identifier">
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.channel.setUpChannelCallerColumnsCaller',
            dm: '调用方',
          })}
          dataIndex="identifier"
          cell={renderCellInput}
          width={220}
        />

        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.channel.setUpChannelCallerColumnsType', dm: '类别' })}
          dataIndex="type"
          cell={renderCellSelect}
        />

        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.channel.setUpChannelCallerColumnsKey',
            dm: 'accessKey / secretKey',
          })}
          dataIndex="asKey"
          cell={asKeyCell}
        />

        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.channel.setUpChannelCallerColumnsAction',
            dm: '操作',
          })}
          cell={actions}
          width={100}
        />
      </Table>
      <div onClick={handleAdd} className="editableTable-add-btn">
        <Icon type="add--circle--filled" />
      </div>
    </div>
  );
};
export default Edit;
